import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chengyunren",
  "use": "icon-chengyunren-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-chengyunren\"><path d=\"M8.381 5.657l1.048.105V6.81H8.38v.838h1.257v1.047H8.381v.734h1.571v1.047H8.381v2.095H6.286v-1.047h1.047v-1.048H5.762V9.43h1.571V8.59H6.076V7.543h1.257v-.838H6.286V5.657h1.047v-.419L9.22 4.19H4.714V3.143H11V4.19L8.38 5.657h.001zm2.724 1.362l1.047-1.048.734.734-1.572 1.571c.315 1.048.629 1.99 1.153 2.829l-.734.733c-1.047-1.676-1.676-3.771-1.78-5.971H11c0 .314.105.733.105 1.152zM5.238 5.762h.42c-.106 2.305-.839 4.4-1.782 5.971L3.143 11a12.33 12.33 0 001.362-4.19H3.143V5.762h2.095zM0 0h15.714v15.714H0V0zm1.048 1.048v13.619h13.619V1.047H1.047z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/chengyunren.svg
// module id = 451
// module chunks = 4